// extracted by mini-css-extract-plugin
export default {"container":"search_commentary_watcher-module__container--23JpU"};